var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-center" }, [
    _c(
      "div",
      { staticClass: "flex-grow-1 mr-2" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { md: "4" } },
              [
                _c("b-input", {
                  attrs: { placeholder: "Vorname" },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.firstName,
                    callback: function($$v) {
                      _vm.firstName = $$v
                    },
                    expression: "firstName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { md: "5" } },
              [
                _c("b-input", {
                  attrs: { placeholder: "Nachname" },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.lastName,
                    callback: function($$v) {
                      _vm.lastName = $$v
                    },
                    expression: "lastName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { md: "3" } },
              [
                _c("b-input", {
                  attrs: {
                    placeholder: "Geburtsjahr (z.B. 1970)",
                    maxlength: "4"
                  },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.yearOfBirth,
                    callback: function($$v) {
                      _vm.yearOfBirth = $$v
                    },
                    expression: "yearOfBirth"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex align-items-center" }, [
      _c(
        "a",
        {
          class: ["ml-2", { invisible: _vm.isLone }],
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("remove")
            }
          }
        },
        [
          _c("Icon", {
            attrs: { icon: "minus-circle", color: "black", size: "1comma5x" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          class: ["ml-2", { invisible: !_vm.isLast || !_vm.valid }],
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("add")
            }
          }
        },
        [
          _c("Icon", {
            attrs: { icon: "plus-circle", color: "black", size: "1comma5x" }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }